// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3fLoq","requiredAsterisk":"Info_requiredAsterisk__2Hr6b"};